const USER = 'user';
const BOOTUP = 'bootup';

export const KEYS = {
  USER,
  BOOTUP,
};

export const LocalStorage = {
  /**
   * Saves a JSON string to local storage.
   * @param key - The key under which the value is stored.
   * @param value - A JSON string to store.
   */
  setItem: (key: string, value: string): void => {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      console.error(
        `Error saving data to localStorage with key "${key}":`,
        error,
      );
    }
  },

  /**
   * Retrieves a JSON string from local storage.
   * @param key - The key to retrieve the value for.
   * @returns The JSON string stored under the key, or null if not found.
   */
  getItem: (key: string): string | null => {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      console.error(
        `Error reading data from localStorage with key "${key}":`,
        error,
      );
      return null;
    }
  },

  /**
   * Removes an item from local storage.
   * @param key - The key to remove from storage.
   */
  removeItem: (key: string): void => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(
        `Error removing data from localStorage with key "${key}":`,
        error,
      );
    }
  },

  /**
   * Clears all data from local storage.
   */
  clear: (): void => {
    try {
      localStorage.clear();
    } catch (error) {
      console.error('Error clearing localStorage:', error);
    }
  },
};
